import React from 'react';
import "./Report.css";

const Report = () => {
  return (
    <div>
      <h2 className='report_head'>This is Journalism page</h2>
    </div>
  );
};

export default Report;